import { LargeLogo, SmallLogo } from '../../Logos/Logos';

type Props = {
  isLoggedIn: boolean;
};

function Logo({ isLoggedIn }: Props) {
  const renderCompleteLogo = (className: string) => {
    return <LargeLogo className={`${className}`} />;
  };

  return (
    // Dynamically re-colours the svg according to light/dark designs
    <div className="[&_path]:text-container-accent" data-track-name="Logo">
      {isLoggedIn ? (
        <>
          {/* 'L' logo for small screens and full 'Lottoland' logo for large screens*/}
          <SmallLogo className="block h-8 sm:hidden" />
          {renderCompleteLogo('hidden h-8 sm:block')}
        </>
      ) : (
        // Render the full logo in the logged-out state
        renderCompleteLogo('h-6 sm:h-7')
      )}
    </div>
  );
}

export { Logo };
